import React from 'react';
import { FadeIn } from './ui';
export const FailedSolutions = () => {
  const failures = [{
    title: 'Traditional meditation',
    desc: 'asks you to "focus," which requires the very willpower you’ve already exhausted all day.'
  }, {
    title: '"Quiet your mind" apps',
    desc: 'give your internal monologue a soundtrack to talk over, rather than stopping it.'
  }, {
    title: 'Counting sheep',
    desc: 'is too rhythmic and predictable, allowing your worries to slip back into the gaps.'
  }, {
    title: 'White noise machines',
    desc: 'drown out the room, but they can’t drown out the voice inside your head.'
  }, {
    title: '"Trying" to sleep',
    desc: 'creates performance anxiety, which releases even more cortisol, keeping you awake longer.'
  }];
  return <section className="py-16 px-6" data-id="element-17">
      <div className="max-w-2xl mx-auto" data-id="element-18">
        <FadeIn data-id="element-19">
          <h2 className="text-3xl text-center mb-12" data-id="element-20">
            Why what you tried didn't work
          </h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-21">
          {failures.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-22">
              <div className="flex gap-4 items-start" data-id="element-23">
                <div className="mt-2 w-1.5 h-1.5 rounded-full bg-amber/50 shrink-0" data-id="element-24"></div>
                <p className="text-lg font-light leading-relaxed text-parchment-muted" data-id="element-25">
                  <span className="text-parchment font-medium" data-id="element-26">
                    {item.title}
                  </span>{' '}
                  {item.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};